import { useMemo } from 'react'
import type { WithdrawalToken } from '../flow/withdrawalFlowConfig'
import { useFlowStepFrame } from '../hooks/useNestedSheetHeight'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { Box, useTheme } from '../theme/restyle'
import { chainIconUri, chainName } from '../utils/chainDisplay'
import { receivableTokens } from '../withdrawal/receiveDestination'
import type { DestinationChain } from '../withdrawal/useWithdrawalDestinationTokens'
import { TokenAndChainPickerScreen } from './TokenAndChainPickerScreen'

export interface SelectReceiveTokenAndChainScreenProps {
  chains: DestinationChain[]
  committed?: WithdrawalToken
  onConfirm: (chainId: number, token: string) => void
  onBack: () => void
}

export function SelectReceiveTokenAndChainScreen({
  chains,
  committed,
  onConfirm,
  onBack,
}: SelectReceiveTokenAndChainScreenProps) {
  const { t } = useFunkitTranslation()
  const theme = useTheme()
  const frame = useFlowStepFrame()
  const tokens = useMemo(
    () =>
      receivableTokens(chains).map((symbol) => ({
        symbol,
        chainIds: chains
          .filter((chain) => chain.symbols.includes(symbol))
          .map((chain) => chain.chainId),
      })),
    [chains],
  )
  return (
    <Box style={{ ...frame, backgroundColor: theme.background.modal }}>
      <TokenAndChainPickerScreen
        title={t('selectReceiveToken.title')}
        tokens={tokens}
        chains={chains.map((chain) => ({
          id: String(chain.chainId),
          name:
            chainName(chain.chainId) ??
            t('networks.chainFallback', { chainId: chain.chainId }),
          iconUri: chainIconUri(chain.chainId),
        }))}
        initialSelection={
          committed
            ? { symbol: committed.symbol, chainId: Number(committed.chainId) }
            : undefined
        }
        onConfirm={({ chainId, symbol }) => onConfirm(chainId, symbol)}
        onBack={onBack}
      />
    </Box>
  )
}
